var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"reminder-checkbox",class:{
    'reminder-checkbox--checked': _vm.checked,
    'reminder-checkbox--expired': _vm.expired
  },model:{value:(_vm.localChecked),callback:function ($$v) {_vm.localChecked=$$v},expression:"localChecked"}},'v-checkbox',_vm.$attrs,false),_vm.inheritListeners))}
var staticRenderFns = []

export { render, staticRenderFns }